
import { defineComponent, ref, PropType } from 'vue'
import { ActivationToEdit, AudienceSettingsSchemaItem } from '../../../../../types/GCB2'
import AudienceSchemaInlineFields from './AudienceSchemaInlineFields.vue'
import { MAILING_ADDITIONAL_SETTINGS_TITLE } from './audienceMailingSettings'

export default defineComponent({
    name: 'AudienceMailingAdditionalSettings',
    components: { AudienceSchemaInlineFields },
    props: {
        groups: { type: Array as PropType<AudienceSettingsSchemaItem[][]>, default: () => [] },
        value: { type: Object, required: true },
        audienceId: { type: [Number, String], required: true },
        lists: { type: Object, required: true },
        massEdit: { type: Boolean, default: false },
        currentActivation: { type: Object as PropType<ActivationToEdit>, required: false },
        start: { type: Number, default: 1 },
    },
    setup() {
        const open = ref(false)
        const isGroupDisabled = (group: AudienceSettingsSchemaItem[]) =>
            group.some((item) => Boolean(item.disabled))
        return {
            open,
            title: MAILING_ADDITIONAL_SETTINGS_TITLE,
            isGroupDisabled,
        }
    },
})
